<template >
  <div class="l-container TodosIndex">

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">id</btn>
        <btn class="m-btn--column" @click.native="switchV('user_id')" v-bind:class="{ 'active': user_id }">user</btn>
        <btn class="m-btn--column" @click.native="switchV('state')" v-bind:class="{ 'active': state }">state</btn>
        <btn class="m-btn--column" @click.native="switchV('note')" v-bind:class="{ 'active': note }">note</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">created_at</btn>
        <btn class="m-btn--column" @click.native="switchV('updated_at')" v-bind:class="{ 'active': updated_at }">updated_at</btn>
      </div>
    </template>

    <div style="display: flex; margin-top: 10px">
      <input type="text" v-model="todo.note" style="border: 1px solid #ccc; height: 27px; padding: 0 5px">
      <btn class="m-btn--column" @click.native="postTodo">post</btn>
    </div>
    {{message}}

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="id"><th-c class="sticky-3 id" @click.native='sort("id")'>id</th-c></template>
          <template v-if="user_id"><th-c class="sticky-3 user_id" @click.native='sort("user_id")'>user</th-c></template>
          <template v-if="state"><th-c class="sticky-3 state false" @click.native='sort("state")'></th-c></template>
          <template v-if="note"><th-c class="sticky-3 note" @click.native='sort("note")'>note</th-c></template>
          <template v-if="created_at"><th-c class="sticky-3 created_at" @click.native='sort("created_at")'>create</th-c></template>
          <template v-if="updated_at"><th-c class="sticky-3 updated_at" @click.native='sort("updated_at")'>update</th-c></template>
          <th-c class="sticky-3 delete"></th-c>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in mapTodosState0" :key="list.id">

          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="user_id"><td-c>{{list.user.user}}</td-c></template>
          <template v-if="state">
            <td-c @click.native="changeState(list)" v-bind:class="{ 'false': list.state === 0 }"></td-c>
          </template>
          <template v-if="note"><td-c><input type="text" @keyup="patchTodo(list)" v-model="list.note"></td-c></template>
          <template v-if="created_at"><td-c>{{list.created_at}}</td-c></template>
          <template v-if="updated_at"><td-c>{{list.updated_at}}</td-c></template>

          <td-c @click.native="deleteTodo(list)" v-ripple><i class="fa fa-fw fa-times"></i></td-c>

        </tr-c>

      </table-c>
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="id"><th-c class="sticky-3 id" @click.native='sort("id")'>id</th-c></template>
          <template v-if="user_id"><th-c class="sticky-3 user_id" @click.native='sort("user_id")'>user</th-c></template>
          <template v-if="state"><th-c class="sticky-3 state true" @click.native='sort("state")'></th-c></template>
          <template v-if="note"><th-c class="sticky-3 note" @click.native='sort("note")'>note</th-c></template>
          <template v-if="created_at"><th-c class="sticky-3 created_at" @click.native='sort("created_at")'>create</th-c></template>
          <template v-if="updated_at"><th-c class="sticky-3 updated_at" @click.native='sort("updated_at")'>update</th-c></template>
          <th-c class="sticky-3 delete"></th-c>
        </tr-c>

        <tr-c class="gray" slot="tr-td" v-for="list in mapTodosState1" :key="list.id">

          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="user_id"><td-c>{{list.user.user}}</td-c></template>
          <template v-if="state">
            <td-c @click.native="changeState(list)" v-bind:class="{ 'true': list.state === 1 }"></td-c>
          </template>
          <template v-if="note"><td-c><input class="gray" type="text" @keyup="patchTodo(list)" v-model="list.note"></td-c></template>
          <template v-if="created_at"><td-c>{{list.created_at}}</td-c></template>
          <template v-if="updated_at"><td-c>{{list.updated_at}}</td-c></template>

          <td-c @click.native="deleteTodo(list)" v-ripple><i class="fa fa-fw fa-times"></i></td-c>

        </tr-c>

      </table-c>
    </div>

  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/todos/search?limit=' + config.LIMIT

// var TIMER = null
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'todo',
  pageNames: 'todos'
}

let _ = window._
export default {
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    todos () {
      return this.$store.getters.todos
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    // order By
    orderedTodos () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.todos, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.todos, this.sortColumn)
      }
    },

    // state = 0
    filteredTodosState0 () {
      let self = this
      return self.orderedTodos.filter((todo) => {
        return todo.state === 0 & todo.user.id === this.user.id
      })
    },

    // state = 1
    filteredTodosState1 () {
      let self = this
      return self.orderedTodos.filter((todo) => {
        return todo.state === 1 & todo.user.id === this.user.id
      })
    },

    // filter
    // filteredTodos () {
    //   let self = this
    //   return self.orderedTodos.filter((todo) => {
    //     return todo.user_id === this.user.id
    //   })
    // },

    // map
    mapTodosState0 () {
      let self = this
      return self.filteredTodosState0.map((todo) => {
        // todo.mapState = self.calcState(todo.state)
        todo.created_at = self.calcDate(todo.created_at)
        todo.updated_at = self.calcDate(todo.updated_at)
        return todo
      })
    },

    // map
    mapTodosState1 () {
      let self = this
      return self.filteredTodosState1.map((todo) => {
        // todo.mapState = self.calcState(todo.state)
        todo.created_at = self.calcDate(todo.created_at)
        todo.updated_at = self.calcDate(todo.updated_at)
        return todo
      })
    }
  },

  directives: {
    focus: {
      inserted: function (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },

  data () {
    return {
      message: '',
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      id: false,
      user_id: true,
      state: true,
      note: true,
      created_at: true,
      updated_at: true,

      todo: {
        id: '',
        user_id: '',
        state: '',
        note: '',
        created_at: '',
        updated_at: ''
      },

      search: {
        id: '',
        user_id: '',
        state: '',
        note: '',
        created_at: '',
        updated_at: '',

        not_id: '',
        not_user_id: '',
        not_state: '',
        not_note: '',
        not_created_at: '',
        not_updated_at: ''
      },

      watch: {
      }
    }
  },

  watch: {
  },

  created () {
  },

  methods: {
    calcDate (value) {
      const datetime = new Date(value)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    calcState (state) {
      if (!state) {
        return '未'
      } else if (state === 1) {
        return '済'
      } else {
        return '他'
      }
    },

    btn1 () {
    },

    btn2 () {
    },

    postTodo () {
      console.log('post')
      this.message = ''
      this.$store.dispatch('postTodo', {
        this: this,
        todo: this.todo
      })
    },

    patchTodo: _.debounce(function (list) { // lodashの場合thisの扱いが違う為allow関数ではなくfunction
      console.log('patch')
      console.log(list)
      console.log(this.$store)
      this.$store.dispatch('patchTodo', {
        list: list
      })
    }, 250),

    deleteTodo (list) {
      this.$store.dispatch('deleteTodo', {
        list: list
      })
    },

    changeState: _.debounce(function (list) { // lodashの場合thisの扱いが違う為allow関数ではなくfunction
      this.$store.dispatch('changeState', {
        list: list
      })
    }, 250),

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    switchV: function (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.user_id = false
      this.state = false
      this.note = false
      this.created_at = false
      this.updated_at = false
    },

    all () {
      this.id = true
      this.user_id = true
      this.state = true
      this.note = true
      this.created_at = true
      this.updated_at = true
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.search.user_id = ''
      this.search.state = ''
      this.search.note = ''
      this.search.created_at = ''
      this.search.updated_at = ''

      this.search.not_id = ''
      this.search.not_user_id = ''
      this.search.not_state = ''
      this.search.not_note = ''
      this.search.not_created_at = ''
      this.search.not_updated_at = ''
      this.searchTable()
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('TodosSearch')
      let obj = JSON.parse(getjson)
      vm.search.id = obj['id']
      vm.search.user_id = obj['user_id']
      vm.search.state = obj['state']
      vm.search.note = obj['note']
      vm.search.created_at = obj['created_at']
      vm.search.updated_at = obj['updated_at']

      vm.search.not_id = obj['not_id']
      vm.search.not_user_id = obj['not_user_id']
      vm.search.not_state = obj['not_state']
      vm.search.not_note = obj['not_note']
      vm.search.not_created_at = obj['not_created_at']
      vm.search.not_updated_at = obj['not_updated_at']
      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {
      id: this.search.id,
      user_id: this.search.user_id,
      state: this.search.state,
      note: this.search.note,
      created_at: this.search.created_at,
      updated_at: this.search.updated_at,

      not_id: this.search.not_id,
      not_user_id: this.search.not_user_id,
      not_state: this.search.not_state,
      not_note: this.search.not_note,
      not_created_at: this.search.not_created_at,
      not_updated_at: this.search.not_updated_at
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('TodosSearch', setjson)
    next()
  },

  mounted () {
  }
}
</script>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */

.fix {
  height: 14px;
  overflow: auto;
}
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.id {
  width: 70px;
}
.user_id {
  width: 100px;
}
.state {
  width: 30px;
  padding: 0;
  cursor: pointer;
}
.created_at {
  width: 120px;
}
.updated_at {
  width: 120px;
}
.delete {
  width: 30px;
  max-width: 30px;
  cursor: pointer;
}
.fa-times {
  font-size: 13px;
}
.false {
  &:after {
    content: "";
    display: block;
    position: relative;
    left: 1px;
    width: 13px;
    height: 13px;
    border-radius: 10px;
    // background: #eee;
    background: #41b883;
  }
}
.true {
  &:after {
    content: "";
    display: block;
    position: relative;
    left: 1px;
    width: 13px;
    height: 13px;
    border-radius: 10px;
    background: #37474F;
  }
}
.index-box {
  height: calc(50vh - 100px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    /* content: "\f1b9"; */
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}

.m-btn--column {
  &:focus {
    background: #37474f;
    color: #fff;
    border: 0;
  }
}

.gray {
  color: #ccc;
}
</style>

<style lang="scss">
.TodosIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// TodosIndex.vue?d2437cc2